import React, { Fragment, useContext, useEffect, useState } from 'react';
import { ActionButton, BaseButton, Button, Checkbox, ContextualMenuItemType, DefaultButton, Dialog, DialogFooter, DialogType, DocumentCard, DocumentCardActions, DocumentCardActivity, DocumentCardLocation, DocumentCardPreview, DocumentCardTitle, Dropdown, IContextualMenuItem, IDropdownOption, Icon, PersonaInitialsColor, PrimaryButton, Text, TextField, Toggle, TooltipHost } from "office-ui-fabric-react";
import { ulid } from 'ulid';
import moment from 'moment-timezone';



import { WsAppContext } from "../../AppContext";

import { Redirect, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
import { Loading } from "../../Shared";
import { WsConfigTenant, WsTenantStatus } from "./ConfigTenant";



import { apiGet, apiPost } from "../../../helpers-sales";
import { WsConfigNormalization } from "./ConfigNormalization";

import { WsDeliverTenantInterface } from "../../../../../core/src/interfaces";

import { getTenantStatus, getWorkloads } from "../data/deliver-data";
import { WsDeliverTenantStatus } from "../../../enums";

import { WsResourcePage } from "./ResourcePage";

import { WsDeliverPortalContext } from "../DeliverPortalContext";
import { WsJobsPage } from "./JobsPage";




import './ConfigPage.scss';









type WsTenantActionButtonProps = {
  tenantType: string;
  tenantId:   string;
  tenant: WsDeliverTenantInterface;
  setTenantActionDialogVisible?: React.Dispatch<React.SetStateAction<WsDeliverTenantAction | undefined>>;
  loadData?: () => Promise<void>;
};

const WsTenantActionButton = (props: WsTenantActionButtonProps) => {

  const portalContext = useContext(WsDeliverPortalContext);

  const history = useHistory();

  const params: { tenantType: string, tenantId?: string, compareTenantId?: string } = useParams();

  const actionItems: IContextualMenuItem[] = props.tenantId === '0190733a-cc6e-7659-8155-c46843079259' ?
  [
    // {
    //   key: 'ws-deliver-tenant-action-clone',
    //   text: 'Clone',
    //   // iconProps: { iconName: 'LightningBolt' },
    //   onClick: () => {
    //     props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'clone' });
    //   }
    // },
    // {
    //   key: 'ws-deliver-tenant-action-blueprint',
    //   text: 'Create Blueprint',
    //   // iconProps: { iconName: 'LightningBolt' },
    //   onClick: () => {
    //     props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'clone' });
    //   }
    // },
    {
      key: 'ws-deliver-tenant-action-delete',
      text: 'Delete',
      disabled: true,
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        // props.setTenantActionDialogVisible({ tenantId: props.tenantId, name: 'deploy' });
      }
    }
  ]
  :
  [
    {
      key: 'ws-deliver-tenant-action-workloads',
      text: 'Workloads',
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        history.push(`/deliver/config/${props.tenantType}/${props.tenantId}`);
      }
    },
    {
      key: 'ws-deliver-tenant-action-compare',
      text: 'Compare Tenants',
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'compare' });
      }
    },
    {
      key: 'divider-1',
      itemType: ContextualMenuItemType.Divider
    },
    {
      key: 'ws-deliver-tenant-action-history',
      text: 'Sync History',
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        history.push(`/deliver/config/${props.tenantType}/${props.tenantId}/history`);
      }
    },
    {
      key: 'ws-deliver-tenant-action-sync',
      text: 'Start Sync',
      // iconProps: { iconName: 'LightningBolt' },
      onClick: async () => {
        setTimeout(async () => {

          const trace = `ws-trace-${ulid().toLowerCase()}`;

          portalContext?.showBackgroundJob({
            text: 'Sync Tenant Configuration',
            text2: 'Starting...',
            url: '',
            id: trace,
            progress: 0.1,
            jobId: 0,
            updateOrCreate: false
          });

          const config = await apiPost(`/deliver/tenants/${props.tenantId}/action`, { trace, action: 'SYNC', ownerEmail: portalContext?.currentUser?.email });

        }, 10);
      }
    },
    {
      key: 'ws-deliver-tenant-action-clone',
      text: 'Clone',
      disabled: [ '50bcdea8-e996-482b-8ca2-b75d8c9eb222', 'f5d27e29-cb6c-45d1-946f-f30fb359f409' ].includes(props.tenantId),
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'clone' });
      }
    },
    {
      key: 'divider-2',
      itemType: ContextualMenuItemType.Divider
    },
    {
      key: 'ws-deliver-tenant-action-migrate',
      text: 'Migrate',
      disabled: true,
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'migrate' });
      }
    },
    {
      key: 'divider-3',
      itemType: ContextualMenuItemType.Divider
    },
    {
      key: 'ws-deliver-tenant-action-backup-history',
      text: 'Backup History',
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        history.push(`/deliver/config/${props.tenantType}/${props.tenantId}/backup-history`);
      }
    },
    {
      key: 'ws-deliver-tenant-action-backup',
      text: 'Start Backup',
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        setTimeout(async () => {

          const trace = `ws-trace-${ulid().toLowerCase()}`;

          portalContext?.showBackgroundJob({
            text: 'Backup Tenant Configuration',
            text2: 'Starting...',
            url: '',
            id: trace,
            progress: 0.1,
            jobId: 0,
            updateOrCreate: false
          });

          const config = await apiPost(`/deliver/tenants/${props.tenantId}/action`, { trace, action: 'BACKUP', ownerEmail: portalContext?.currentUser?.email });

        }, 10);
      }
    },
    {
      key: 'ws-deliver-tenant-action-restore',
      text: 'Restore',
      disabled: [ '50bcdea8-e996-482b-8ca2-b75d8c9eb222', 'f5d27e29-cb6c-45d1-946f-f30fb359f409' ].includes(props.tenantId),
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'restore' });
      }
    },
    {
      key: 'divider-4',
      itemType: ContextualMenuItemType.Divider
    },
    {
      key: 'ws-deliver-tenant-action-blueprint',
      text: 'Create Blueprint',
      disabled: true,
      // iconProps: { iconName: 'LightningBolt' },
      onClick: () => {
        props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'blueprint' });
      }
    },
    // {
    //   key: 'ws-deliver-tenant-action-deploy',
    //   text: 'Deploy',
    //   disabled: true,
    //   // iconProps: { iconName: 'LightningBolt' },
    //   onClick: () => {
    //     props.setTenantActionDialogVisible?.({ tenantId: props.tenantId, name: 'deploy' });
    //   }
    // },
    // {
    //   key: 'ws-deliver-tenant-action-delete',
    //   text: 'Delete',
    //   // iconProps: { iconName: 'LightningBolt' },
    //   onClick: () => {
    //     // props.setTenantActionDialogVisible({ tenantId: props.tenantId, name: 'deploy' });
    //   }
    // }
  ];

  if (getTenantStatus(props.tenant, 'Status') !== WsDeliverTenantStatus.Ready) {

    actionItems.push(
      {
        key: 'ws-deliver-tenant-action-stop',
        text: 'Stop (Current Action)',
        disabled: true,
        // iconProps: { iconName: 'LightningBolt' },
        onClick: () => {
          setTimeout(async () => {

            const config = await apiPost(`/deliver/tenants/${props.tenantId}/action`, { action: 'STOP' });
  
            if (config && config.deliverTenant) {
              await props.loadData?.();
            }

          }, 10);
        }
      }
    );
  }

  return (
    <>
      <DefaultButton
        className="qt-tenant-button"
        text={params.tenantId ? 'Current Configuration' : 'Show' }
        split
        menuProps={{
          items: actionItems
        }}
        onClick={() => {
          history.push(`/deliver/config/${props.tenantType}/${props.tenantId}${ params.tenantId ? '' : '' }`);
        }}
      />
    </>
  );
};








export interface WsDeliverTenantAction {
  name:     string;
  tenantId: string;
}






export {
  WsTenantActionButton
};
